import { useAtom } from 'jotai'

import {
  title,
  button,
} from './style'
import { Button } from 'components/Button'
import { Spacer } from 'components/Spacer'
import { Subtitle02 } from 'components/Typography/Subtitle02'
import {
  recallModalIsOpenAtom,
  recallCountAtom
} from 'states'
import { Icon } from 'icons/Icon'
import { Color } from 'utils/variables'

export const Reconnect = () => {
  const [, setIsOpenRecallModal] = useAtom(recallModalIsOpenAtom)
  const [, setRecallCount] = useAtom(recallCountAtom)

  return (
    <>
      <div className={title}>
        <Icon name="Cry" size={44} />
        <Subtitle02 color={Color.LightBlack}>お問い合わせをするには、再度オペレーターにお繋ぎ直しください。</Subtitle02>
      </div>
      <Spacer size={26}/>
      <Button
        size="large"
        classname={button}
        onClick={() => {
          setIsOpenRecallModal(false)
          setRecallCount((recallCount) => recallCount + 1)
        }}>
          繋ぎ直す
      </Button>
    </>
  );
}

